/* eslint-disable @typescript-eslint/no-misused-promises */
import {
  DeleteLikeButton,
  ImpressionObserver,
  MainImageWithOptimized,
} from '@/app/ui/parts/default/sp/parts/itemCardClient'
import { slimItemType } from '@/lib/item/server'
import { getDiscountedPrice } from '@/lib/item/util'
import { serviceType } from '@/lib/service/server'
import { formatSizeToDisplay } from '@/lib/size/util'

type ItemCardProps = {
  service: serviceType
  item: slimItemType
  isLiked?: boolean
  index?: number
  main?: boolean
  ranking?: boolean
  slider?: boolean
}

export const ItemCard: React.FC<ItemCardProps> = ({
  item,
  service,
  isLiked,
  index,
  slider = false,
}) => {
  const className = `item-card w-1/2 p-1 md:w-1/3 lg:w-1/4 xl:w-1/5 ${slider ? 'min-w-[170px]' : ''}`
  const discountedPrice = getDiscountedPrice(item)
  return (
    <div className={className}>
      <ImpressionObserver item_id={item.item_id} price={item.price} />
      <div className="item-card-container h-44 relative bg-white">
        <MainImageWithOptimized
          item_id={item.item_id}
          image_url={item.image_url}
          name={item.name}
          price={item.price}
        />
        {discountedPrice > 0 && (
          <div
            className="item-card-image-sale main-color absolute bottom-1 left-1 rounded-md w-12 h-8 flex justify-center items-center text-white"
            style={{
              padding: '6px 11px',
              borderRadius: '26px',
            }}
          >
            <p className="text-xs font-bold">SALE</p>
          </div>
        )}
        {item.is_popular && !index && (
          <div
            className="item-card-image-popular main-color absolute top-0 right-0 rounded-bl-full text-white"
            style={{
              padding: '3px 3px 11px 11px',
            }}
          >
            <p className="item-card-image-popular-text text-sm font-bold">
              人気
            </p>
          </div>
        )}
        {index && index > 0 && index <= 100 && (
          <div
            className="item-card-image-ranking main-color absolute top-0 left-0 rounded-br-full text-white"
            style={{
              padding: '4px 15px 12px 8px',
            }}
          >
            <p className="font-bold text-xl">
              {index}
              <span className="ml-1 text-sm">位</span>
            </p>
          </div>
        )}
        {isLiked && service && (
          <DeleteLikeButton
            service_id={service.service_id}
            item_id={item.item_id}
          />
        )}
      </div>
      <a className="item-description-container" href={`/item/${item.item_id}`}>
        <div className="item-card-description-container bg-white p-2 overflow-hidden leading-snug min-h-[88px]">
          {discountedPrice > 0 ? (
            <p className="item-card-description-price text-black text-base mb-1 font-bold flex items-center">
              ¥{discountedPrice.toLocaleString()}{' '}
              <span className="item-card-description-price-original text-gray-500 text-xs ml-1 line-through">
                ¥{item.price} (割引前)
              </span>
            </p>
          ) : (
            <p className="item-card-description-price text-black text-base mb-1 font-bold">
              ¥{item.price.toLocaleString()}{' '}
              <span className="item-card-description-tax font-light text-sm">
                (税込)
              </span>
            </p>
          )}
          {!item.stock && (
            <p className="text-sm text-[#4f5256] font-bold ml-1">売り切れ</p>
          )}
          <div className="item-card-description-text text-[13px] text-black max-h-[35px] overflow-hidden my-1">
            <h3>{item.name}</h3>
          </div>
          {item.tags && item.tags.length > 0 && (
            <div className="item-card-tag-list hidden bg-white py-1">
              <div className="flex overflow-x-auto whitespace-nowrap">
                {item.tags.map((tag) => (
                  <div
                    key={tag.tag_id}
                    className={
                      `tag-${tag.tag_id}` +
                      ' bg-[#f1f1f1] text-[#4f5256] text-[11px] px-1 py-1 mr-1 mt-1 rounded-sm'
                    }
                  >
                    {tag.name}
                  </div>
                ))}
              </div>
            </div>
          )}
          {item.sizes && item.sizes.length > 0 && (
            <div className="item-card-size-list hidden bg-white py-1">
              <div className="flex overflow-x-auto whitespace-nowrap">
                {item.sizes.map((size) => (
                  <div
                    key={size.size_id}
                    className={
                      `size-${size.size_id}` +
                      ' bg-[#f1f1f1] text-[#4f5256] text-[11px] px-1 py-1 mr-1 mt-1 rounded-sm'
                    }
                  >
                    {formatSizeToDisplay(size)}
                  </div>
                ))}
              </div>
            </div>
          )}
          {item.colors && item.colors.length > 0 && (
            <div className="item-card-color-code-list hidden bg-white py-1 flex items-center justify-between">
              <div className="flex">
                {item.colors
                  .filter(
                    (color) => color.color_code && color.color_code !== '',
                  )
                  .map((color, index) => (
                    <div
                      key={color.color_id}
                      className={`h-[13px] w-[13px] rounded-full mr-1 mt-1 ${index > 8 ? 'hidden' : ''}`}
                      style={{
                        backgroundColor: color.color_code,
                        border:
                          color.color_code.includes('#fff') ||
                          color.color_code.includes('#FFF')
                            ? '1px solid #999'
                            : 'none',
                      }}
                    ></div>
                  ))}
              </div>
              {item.colors.length > 1 && (
                <div className="item-card-color-count text-[#4f5256] text-[11px] mr-1">
                  全{item.colors.length}色
                </div>
              )}
            </div>
          )}
        </div>
      </a>
    </div>
  )
}
